import { render } from "./AdditionalContentAlerts.vue?vue&type=template&id=077573fc&ts=true"
import script from "./AdditionalContentAlerts.vue?vue&type=script&lang=ts"
export * from "./AdditionalContentAlerts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__